import { signalStore, withState } from '@ngrx/signals';
import { initialRoleState } from './role.state';
import { withRoleApiMethods } from './role.methods.api';

export const RoleStore = signalStore(
    { providedIn: 'root' },
    withState(initialRoleState),
    withRoleApiMethods
);
